import { Component } from '@angular/core';
import {DeviceService} from "./modules/device/device.service";
import {AuthService} from "../../modules/auth/api/service/auth.service";
import {BreadcrumbService} from "./modules/core/breadcrumb/api/breadcrumb.service";
import {BaseView} from "../../modules/core/view/base.view";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-root',
    template: `
    <div class="luna-screen d-flex flex-col">
        <app-ai-realtime-audio></app-ai-realtime-audio>
        <div class="top flex-grow-0 p-8 d-flex">
            <div class="breadcrumb flex-grow-1">
                <div class="d-flex gap-8 align-items-center">
                    <ng-container *ngIf="(breadcrumbService.text$ | async) as text">
                        <div class="flex-grow-0 flex-shrink-0">
                            <app-luna-button color="white" iconName="home" (clickedEvent)="redirectToHome()"></app-luna-button>
                        </div>
                        <div class="flex-grow-1 flex-shrink-1">
                            {{text.text}}
                        </div>
                    </ng-container>
                </div>
                
            </div>
            <ng-container *ngIf="breadcrumbService.buttons$ | async as buttons">
                <div class="buttons flex-grow-0 flex-shrink-0" *ngIf="buttons?.length > 0">
                    <ng-container *ngFor="let button of buttons">
                        <app-luna-button *ngIf="!button.imageUrl"  [iconName]="button.iconName" (clickedEvent)="button.onClick()" color="white"></app-luna-button>
                        <img (click)="button.onClick()" *ngIf="button.imageUrl" [src]="button.imageUrl" [style.width.px]="50" class="cursor-pointer"/>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div class="center flex-grow-1 p-8">
            <router-outlet></router-outlet>
        </div>
        <div class="bottom flex-grow-0 d-flex p-16">
            <div class="text-left">
                {{ version }}
            </div>
            <div class="text-right">
                <!-- <ng-container *ngIf="(deviceService.serialNumber$ | async) as serialNumber else noSerial">
                    N° {{serialNumber}}
                </ng-container>
                <ng-template #noSerial> /</ng-template> -->
                <ng-container *ngIf="(authService.tokenContent$ | async)?.account as account">{{account?.name}}</ng-container>
                
                <ng-container *ngIf="(authService.tokenContent$ | async)?.name as userName else noUser"> / {{userName}}</ng-container>
                <ng-template #noUser>Non connecté</ng-template>
            </div>
        </div>
    </div>
    
  `,
    styleUrls: ['./main.component.scss']
})
export class MainComponent extends BaseView {
    protected readonly window = window;
    version = '?';
    token: string;

    constructor(public authService: AuthService,
                public breadcrumbService: BreadcrumbService,
                public deviceService: DeviceService) {
        super();
        this.version = environment.version;
    }

    redirectToHome() {
        this.redirectToWithinCurrentApp('home');
        this.breadcrumbService.text = undefined;
    }
}
